import * as React from "react";

import { TestWrapper } from "@ui/Atoms/TestWrapper";

import * as Styled from "./CalendarNotification.styled";

interface Props {
  testId?: string;
  className?: string;
  children: React.ReactNode;
  minHeight?: number;
}

const Container = (props: Props): React.ReactElement => (
  <TestWrapper testId={props.testId}>
    <Styled.Container className={props.className} minHeight={props.minHeight}>
      {props.children}
    </Styled.Container>
  </TestWrapper>
);

export { Container };
